import React, { FC, useContext } from "react";

// MUI 
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { useTheme, useMediaQuery } from "@mui/material";


// MUI Icons
import DeleteIcon from "@mui/icons-material/Delete";

// Open Layers
import OlPoint from "ol/geom/Point";

// Custom Components
import { RoutePoint } from "../PublicPage/SidebarPanes/PublicRoutesPane";
import MapContext from "@/components/Map/MapContext";

// Types
import { DCRecord } from "@/@types/lib/dataController";

export type RouteListItemProps = {
  // TODO use generic type instead of RoutePoint
  item: RoutePoint;
  index: number;
  readOnly?: boolean;
  handleDeleteItem: (indexToDelete: number) => void;
};

const RouteListItem: FC<RouteListItemProps> = ( props ) => {

  const { item, index, readOnly, handleDeleteItem } = props;

  const mapContext = useContext(MapContext);

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down("md"));

  const handleExplore = (evt: React.MouseEvent<HTMLDivElement> | null, selectedItem: DCRecord) => {
    const coord = selectedItem["coord"] as number[];
    if (coord) {
      const p = new OlPoint(coord);

      if (mapContext && mapContext.map) {
        const view = mapContext.map.getView();
        const extent = p.getExtent();

        const padding = isMobile ? [20, 20, 300, 20] : [20, 20, 20, 20]
        if (extent)
          view.fit(extent, { padding, duration: 500, maxZoom: 15 });
      }
    }
  }

  return (
    <ListItemButton
      onClick={(evt) => handleExplore(evt, item)}
    >
      <ListItemAvatar>
        <Avatar sx={{ width: 28, height: 28, bgcolor: "primary.main", fontSize: "16px" }}>{index + 1}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={item.label} />
      {!readOnly ? 
      <IconButton
        onClick={(evt) => {
          handleDeleteItem(index)
          evt.stopPropagation()
        }}
      >
        <DeleteIcon />
      </IconButton>
      : null }
    </ListItemButton>
  );
};

export default RouteListItem;
